import { Grid, makeStyles, Typography } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import Button from "@material-ui/core/Button/Button"
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from "../../assets/images/png/Search.png"
import "@fontsource/ubuntu"
import Modal from "@material-ui/core/Modal"
import { useSelector } from 'react-redux';
const useStyles = makeStyles({
    main: {
        height: "3rem",
        display: "flex",
        alignItems: "center"
    },
    add: {
        background: "transparent",
    },
    btn: {
        background: "transparent",
        border: "2px solid #14AFF1",
        color: "white",
        borderRadius: "6px",
        textTransform: "none",
        height: "4.5vh",
        fontSize: "1rem",
        fontFamily: "Ubuntu",
        fontWeight: 300,
        padding: "0 0.7rem",
        "&:disabled": {
            border: "2px solid #97A1A9",
            // borderColor: "#97A1A9",
            color: "#97A1A9"
        }
    },
    search: {
        width: "14vw",
        border: "2px solid #356680",
        outline: "none",
        paddingLeft: "1rem",
        paddingRight: "1.8rem",
        background: "#283A46",
        color: "#97A1A9",
        backgroundImage: `url(${SearchIcon})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "98% 50%",
        fontSize: "1rem",
        "&::placeholder": {
            color: "#97A1A9"
        }
    },
    grid: {
        display: "flex",
        justifyContent: "space-around"
    },
    editSymbol: {
        fontSize: "1.15rem",
        marginRight: "0.3rem",
    },
    modalMain: {
        width: "37rem",
        height: "20rem",
        position: "absolute",
        top: "26%",
        left: "30%",
        boxShadow: 24,
        background: "#2A3E4C",
        color: "white",
        borderRadius: 5,
        padding: "0.2rem 0"
    },
    modalHead: {
        padding: "0 1.5rem",
        height: "20%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "1.5rem",
        borderBottom: "1px solid #1A262F"
    },
    text: {
        fontSize: "1.1rem"
    },
    cross: {
        cursor: "pointer",
        fontSize: "1.1rem"
    },
    modalBody: {
        padding: "0 1.5rem",
        height: "60%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderBottom: "1px solid #1A262F"

    },
    modalFooter: {
        padding: "0 1.5rem",
        display: "flex",
        height: "20%",
        alignItems: "center",
        justifyContent: "space-between"
    },
    modalBtn: {
        background: "transparent",
        border: "2px solid #14AFF1",
        fontSize: "1rem",
        borderRadius: "6px",
        padding: "0.3rem 1rem",
        color: "white",
        cursor: "pointer",
        marginLeft: "1rem"
    },
    modalCancel: {
        background: "transparent",
        border: "none",
        color: "#14AFF1",
        fontSize: "1rem",
        cursor: "pointer"
    },
    modalAdd: {
        background: "#14AFF1"
    },
    predict: {
        background: "#97A1A9",
        border: "2px solid #97A1A9",
        "&:hover": {
            background: "#14AFF1",
            border: "2px solid #14AFF1"
        }
    },
    viewBtn: {
        color: "#97A1A9",
        border: "2px solid #97A1A9"
    }
})
const GridHeader = () => {
    const checkBoxCount = useSelector(state => state.CheckBoxCount)
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [editBool, setEditBool] = useState(true);
    const [deleteBool, setDeleteBool] = useState(true);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false)

    useEffect(() => {
        checkBoxCount === 1 ? setEditBool(false) : setEditBool(true);
        checkBoxCount >= 1 ? setDeleteBool(false) : setDeleteBool(true);

    }, [checkBoxCount]);
    return (
        <div className={classes.main}>
            <Grid container>
                <Grid item xs={3} className={classes.grid} >
                    <Button variant="outlined" className={`${classes.btn} ${classes.predict}`} >Predict</Button>
                    <Button variant="outlined" className={`${classes.btn} ${classes.viewBtn}`}>View Correspondence</Button>
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={5} className={classes.grid}>
                    <Button variant="outlined" className={classes.btn} onClick={handleOpen} >+ Add</Button>
                    <Button variant="outlined" className={classes.btn} disabled={editBool}><EditIcon className={classes.editSymbol} /> Edit</Button>
                    <Button variant="outlined" className={classes.btn} disabled={deleteBool} >− Delete</Button>
                    <input type="text" className={`${classes.btn} ${classes.search}`} placeholder="Search By Invoice Number" />
                </Grid>
            </Grid>

            <Modal
                open={open}
                onClose={handleClose}
            >
                <div className={classes.modalMain}>
                    <div className={classes.modalHead}>
                        <Typography className={classes.text}>Add Invoice</Typography>
                        <span onClick={handleClose} className={classes.cross}>&#x2715;</span>
                    </div>
                    <div className={classes.modalBody}>
                        <Typography variant="h5">Invoices Added</Typography>
                    </div>
                    <div className={classes.modalFooter}>
                        <button className={classes.modalCancel} onClick={handleClose}>Cancel</button>
                        <div >
                            <button className={classes.modalBtn}>Clear</button>
                            <button className={`${classes.modalBtn} ${classes.modalAdd}`} onClick={handleClose}>Add</button>
                        </div>
                    </div>
                </div>
            </Modal>

        </div>
    )
}

export default GridHeader
